import React from "react";
import "./PageHeader.css";

const PageHeader = ({ title, breadcrumbs, background }) => {
  return (
    <div
      className="page-header"
      style={{ backgroundImage: `url(${background})` }}
    >
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/>

      <div className="overlay"></div>
      <div className="header-content">
        <h1>{title}</h1>
        {breadcrumbs && (
          <div className="breadcrumbs">
            {breadcrumbs.map((crumb, index) => (
              <span key={index}>
                {crumb}
                {index < breadcrumbs.length - 1 && " / "}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
